import { computed } from 'vue';

export function useFieldErrors(errors, errorName) {
  const errorsSource = computed(() => {
    if (errors) {
      return errors;
    }

    return undefined;
  });

  const hasError = computed(() => {
    if (!errorsSource.value || !errorName.value) {
      return false;
    }

    return errorsSource.value.has(errorName.value);
  });

  const errorMessages = computed(() => {
    if (!hasError.value || !errorName.value) {
      return [];
    }

    return errorsSource.value.get(errorName.value);
  });

  return { hasError, errorMessages, errorsSource };
}
